import endpoints from "../constants/env/middletier";
import React, { useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import ProjectContextDropdown from '../components/ProjectContextDropdown';
import { useProject } from "../context/ProjectContextProvider";
import { useAuth } from '../AuthProvider'

export default function CxEquipmentPage() {
    const [allEquipment, setAllEquipment] = useState(null);
    const [equipmentParameters, setEquipmentParameters] = useState([]);
    const [equipmentName, setEquipmentName] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [columnExpanded, setColumnExpanded] = useState(false);
    const toast = useRef(null);
    const { project } = useProject();
    const { keycloak } = useAuth()

    const [columns, setColumns] = useState([
        {field: 'name', header: 'Name'},
        {field: 'category', header: 'Category'},
        {field: 'installDate', header: 'Installation Date'},
        {field: 'location', header: 'Location'},
        {field: 'serves', header: 'Serves'},
        {field: 'projectId', header: 'projectId'}
    ]);

    const fetchEquipment = async () => {
        try {
            await keycloak.updateToken(30);
            const equipmentByProject = await fetch(`${endpoints.cxequipmentbyproject}${project.value}`, {
            // const equipmentByProject = await fetch(Endpoints["cxequipmentbyproject"] + project.value, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!equipmentByProject.ok) {
                throw new Error("Logs: Bad response");
            }

            const projectsData = await equipmentByProject.json();
            console.log(projectsData);
            setAllEquipment(projectsData);

        } catch (error) {
            console.error("Failed to fetch clients:", error);
        }
    };

    useEffect(() => {
        fetchEquipment();
    }, []);

    const handleAddColumns = async (e) => {
        e.preventDefault();

        try {
            if(columnExpanded){
                setColumns(prev => [
                    {field: 'name', header: 'Name'},
                    {field: 'category', header: 'Category'},
                    {field: 'installDate', header: 'Installation Date'},
                    {field: 'location', header: 'Location'},
                    {field: 'serves', header: 'Serves'}
                ]);
                setColumnExpanded(false);
            } else {
                setColumns(prev => [
                    ...prev,
                    {field: 'drawingRef', header: 'Drawing Ref'},
                    {field: 'specRef', header: 'Spec Ref'},
                    {field: 'tag', header: 'Tag'},
                    {field: 'warrantyDate', header: 'Warranty Date'}
                ]);
                setColumnExpanded(true);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
        }
    };

    const header = (
        <div className="flex align-items-center justify-content-between">
            <span className="text-xl text-900 font-bold">
                Equipment
            </span>

            <div className="p-inputgroup" style={{ width: 'auto' }}>
                {/*<Button icon="pi pi-plus" rounded text severity="secondary" onClick={() => setAddIssueFormVisible(true)} />*/}
                {/*<Button icon="pi pi-refresh" rounded text severity="secondary" onClick={() => fetchEquipment()} />*/}
                <Button icon={columnExpanded ? 'pi pi-caret-left' : 'pi pi-caret-right'}  label={columnExpanded ? 'Less Columns...' : 'All Columns...'}
                        text severity="secondary" onClick={handleAddColumns} />
            </div>
        </div>
    );

    const onRowSelect = async (event) => {
        try {
            await keycloak.updateToken(30);

            const response = await fetch(`${endpoints.cxequipment}/${event.data.id}/parameters/`, {
            // const response = await fetch(Endpoints["cxequipment"] + event.data.id + "/parameters/", {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!response.ok) throw new Error("Bad response");
            const data = await response.json();
            setEquipmentParameters(data);
            setEquipmentName("Parameters for:  " + event.data.name);
            setDialogVisible(true);
        } catch (error) {
            console.error("Failed to fetch clients:", error);
        }
    };

    const handleProjectSelection = async (e) => {
        e.preventDefault();
        await keycloak.updateToken(30);

        const equipmentByProject = await fetch(`${endpoints.cxequipmentbyproject}/${e.value}`, {
        // const equipmentByProject = await fetch(Endpoints["cxequipmentbyproject"] + e.value, {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${keycloak.token}`,
            },
        });


        if (!equipmentByProject.ok) {
            throw new Error("Logs: Bad response");
        }

        const projectsData = await equipmentByProject.json();
        setAllEquipment(projectsData);
    };

    const handleProjectSelectionDataTable = async (e) => {
        console.log(e);
        await keycloak.updateToken(30);

        const equipmentByProject = await fetch(`${endpoints.cxequipmentbyproject}/${e}`, {
        // const equipmentByProject = await fetch(Endpoints["cxequipmentbyproject"] + e, {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${keycloak.token}`,
            },
        });


        if (!equipmentByProject.ok) {
            throw new Error("Logs: Bad response");
        }

        const projectsData = await equipmentByProject.json();
        setAllEquipment(projectsData);
    };

    return (
        <>
            {/*<ProjectContextDropdown onProjectChange={handleLogSelection} />*/}
           <ProjectContextDropdown onProjectChange={handleProjectSelectionDataTable} />
           <Toast ref={toast} />

            <div className="card">
                <DataTable value={allEquipment} header={header} tableStyle={{ minWidth: '50rem' }}
                           selectionMode="single" onRowSelect={onRowSelect}>
                    {columns.map((col, i) => (
                        <Column key={col.field} field={col.field} header={col.header} />
                    ))}
                </DataTable>
            </div>

            <Dialog header={equipmentName} visible={dialogVisible} style={{ width: '50vw' }}
                    onHide={() => setDialogVisible(false)}>
                <DataTable value={equipmentParameters} stripedRows showGridlines tableStyle={{ minWidth: '50rem' }}>
                    <Column field="label" header="Parameter Name"></Column>
                    <Column field="value" header="Parameter Value"></Column>
                </DataTable>
            </Dialog>
        </ >
    );
}























